export const TEAM_CODES: Record<string, string> = {
	Vietnam: 'VIE',
	Thailand: 'THA',
	Malaysia: 'MAS',
	Indonesia: 'IDN',
	Singapore: 'SIN',
	Myanmar: 'MYA',
	Philippines: 'PHI',
	Cambodia: 'CAM',
	Laos: 'LAO',
	Brunei: 'BRU',
	'Timor-Leste': 'TLS',
}

export const getTeamCode = (teamName?: string | null): string => TEAM_CODES[teamName ?? ''] ?? teamName ?? ''
